import logger from '~/utils/log';

export default defineNuxtPlugin(() => {
    let logLevel: string | null = null;

    if (import.meta.server) {
        logLevel = useRuntimeConfig().logLevel;
    } else {
        logLevel = useRuntimeConfig().public.logLevel;
    }

    if (logLevel) {
        logger.setLogLevel(logLevel);
    }
});
